import { TimeUnit } from '../../../../apps/legacy-app/src/components/common/form/TimeInput';

export enum TimeInputOutputUnit {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  YEARS = 'YEARS',
}


export const toTimeInputOutputUnit = (unit: TimeUnit): TimeInputOutputUnit => {
  switch (unit) {
    case 'seconds':
      return TimeInputOutputUnit.SECONDS;
    case 'minutes':
      return TimeInputOutputUnit.MINUTES;
    case 'hours':
      return TimeInputOutputUnit.HOURS;
    case 'days':
      return TimeInputOutputUnit.DAYS;
    case 'months':
      return TimeInputOutputUnit.MONTHS;
    case 'years':
      return TimeInputOutputUnit.YEARS;
  }
};
